<template>
  <div class="dealer-form">

    <div class="columns">
      <div class="column">
        <validation-field label="Name" :validation="validation.name">
          <b-input v-model="editDealer.name" placeholder="Dealer Name" :size="sizeClass" @focus="validation.name.msg = ''" />
        </validation-field>
      </div>
      <div class="column">
        <b-field label="Premium Dealer" :custom-class="sizeClass">
          <b-checkbox v-model="editDealer.premium" :size="sizeClass">{{ editDealer.premium == '1' ? 'Yes' : 'No'}}</b-checkbox>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <validation-field label="Email Address" :validation="validation.email">
          <b-input v-model="editDealer.email" placeholder="Email Address" :size="sizeClass" @focus="validation.email.msg = ''" />
        </validation-field>
      </div>
      <div class="column">
        <b-field label="Website" :custom-class="sizeClass">
          <b-input v-model="editDealer.web" :size="sizeClass" />
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half">
        <validation-field label="Phone Number" :validation="validation.phone">
          <b-input v-model="editDealer.phone" placeholder="Phone Number" :size="sizeClass" @focus="validation.phone.msg = ''" />
        </validation-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Description" :custom-class="sizeClass">
          <b-input type="textarea" v-model="editDealer.description" :size="sizeClass" />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Products / Categories" :custom-class="sizeClass">
          <section>
            <div class="field" v-for="cat in categories" :key="cat.id">
              <b-checkbox v-model="cat.selected" :size="sizeClass">{{ cat.name }}</b-checkbox>
            </div>
          </section>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <validation-field label="Address" :validation="validation.address">
          <b-input v-model="editDealer.address" placeholder="Address" :size="sizeClass" @focus="validation.address.msg = ''" />
        </validation-field>
      </div>
      <div class="column">
        <validation-field label="City" :validation="validation.city">
          <b-input v-model="editDealer.city" placeholder="City" :size="sizeClass" @focus="validation.city.msg = ''" />
        </validation-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <validation-field label="State" :validation="validation.state">
          <b-select v-model="editDealer.state" placeholder="Select a state" :size="sizeClass" @focus="validation.state.msg = ''" expanded>
            <option v-for="item in states" :value="item" :key="item">{{ item }}</option>
          </b-select>
        </validation-field>
      </div>
      <div class="column">
        <validation-field label="Postcode" :validation="validation.postcode">
          <b-input type="number" v-model="editDealer.postcode" placeholder="City" :size="sizeClass" @focus="validation.postcode.msg = ''" />
        </validation-field>
      </div>
    </div>
     <div class="columns">
      <div class="column is-half">
        <b-field label="Coordinate">
          <span v-if="validCood">{{ editDealer.lat }}, {{ editDealer.lng }}</span>
          <span v-else class="italic">invalid address</span>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <button v-if="validCood" class="button is-small" style="margin-bottom: 2px;" @click="centreMap">Centre Map</button>
        <div class="map" ref="mapDiv"></div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-6">
        <b-message title="Error!" type="is-danger" size="is-small" :active.sync="showErr">{{ errMsg }}</b-message>
      </div>
    </div>

    <div class="buttons">
      <button class="button is-success" :class="{'is-loading': submitting}" @click="submit()">{{ !newDealer ? 'Update Dealer' : 'Add Dealer'}}</button>
      <button class="button is-danger" v-if="!newDealer" @click="deleteDealer()">Delete Dealer</button>
    </div>

  </div>
</template>

<script>
import ValidationField from '@/components/ValidationField'
export default {
  name: 'DealerForm',
  components: {
    ValidationField
  },
  props: ['dealer'],
  data () {
    return {
      editDealer: {},
      categories: [],
      states: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
      sizeClass: 'is-small',
      validation: {
        name: { msg: '' },
        phone: { msg: '' },
        email: { msg: '', type: 'email' },
        address: { msg: '' },
        city: { msg: '' },
        state: { msg: '' },
        postcode: { msg: '' }
      },
      map: null,
      mapDefaults: {
        center: { lat: -25.274398, lng: 133.775136 },
        zoom: 4
      },
      marker: null,
      debounceTime: 1000,
      debounceTimer: null,
      hasFirstAddress: false,
      submitting: false,
      showErr: false,
      errMsg: ''
    }
  },
  computed: {
    newDealer () { return !this.dealer || !this.dealer.id },
    addressString () {
      return `${this.editDealer.address} ${this.editDealer.city}, ${this.editDealer.state} Australia`
    },
    coord () {
      return {
        lat: this.editDealer && this.editDealer.lat !== null ? Number(this.editDealer.lat) : null,
        lng: this.editDealer && this.editDealer.lng !== null ? Number(this.editDealer.lng) : null
      }
    },
    validCood () {
      return this.coord.lat !== null && this.coord.lng !== null && !isNaN(this.coord.lat) && !isNaN(this.coord.lng)
    }
  },
  watch: {
    dealer () { this.prepareDealer() },
    coord () { this.showMarker() },
    addressString () {
      if (!this.hasFirstAddress) {
        this.hasFirstAddress = true
        return
      }
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(this.geocodeAddress, this.debounceTime)
    }
  },
  created () {
    this.$api('getCategories')
      .then(resp => {
        this.categories = resp.data
        this.prepareDealer()
      })
  },
  mounted () {
    this.map = new google.maps.Map(this.$refs.mapDiv, { // eslint-disable-line no-undef
      center: this.mapDefaults.center,
      zoom: this.mapDefaults.zoom,
      disableDefaultUI: false
    })
    this.showMarker()
  },
  methods: {
    geocodeAddress () {
      let address = encodeURI(this.addressString)
      let url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address}$region=au&key=${this.$store.getters.googleApiKey}`
      this.$http.get(url)
        .then(resp => {
          if (resp.data.status === 'OK' && resp.data.results.length) {
            this.editDealer.lat = resp.data.results[0].geometry.location.lat
            this.editDealer.lng = resp.data.results[0].geometry.location.lng
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    showMarker () {
      if (!this.map || !this.validCood) {
        if (this.marker) {
          this.marker.setMap(null)
          this.marker = null
        }
      } else {
        if (this.marker) {
          this.marker.setPosition(this.coord)
        } else {
          this.marker = new google.maps.Marker({ // eslint-disable-line no-undef
            position: this.coord,
            map: this.map
          })
        }
        this.centreMap()
      }
    },
    centreMap () {
      if (this.validCood) {
        this.map.panTo(this.coord)
        if (this.map.getZoom() < 11) {
          this.map.setZoom(11)
        }
      }
    },
    submit () {
      if (this.submitting) {
        return
      }
      if (!this.$utils.validate(this.validation, this.editDealer)) {
        this.$snackbar.open({
          message: 'Dealer form data invalid!',
          type: 'is-warning',
          position: 'is-bottom',
          indefinite: false
        })
        return
      }
      this.showErr = false
      this.submitting = true
      let categories = []
      for (let cat of this.categories) {
        if (cat.selected) {
          categories.push({ id: cat.id })
        }
      }
      this.editDealer.categories = categories
      this.$api(this.newDealer ? 'addDealer' : 'updateDealer', { dealer: this.editDealer })
        .then(resp => {
          this.submitting = false
          this.$snackbar.open({
            message: 'Dealer successfully updated!',
            type: 'is-success',
            position: 'is-bottom',
            indefinite: false
          })
          this.$emit('submitted')
        })
        .catch(err => {
          this.errMsg = `Could not submit dealer. ${err.toString()}`
          this.showErr = true
          this.submitting = false
        })
    },
    deleteDealer () {
      this.$dialog.confirm({
        title: `Delete Dealer`,
        message: 'Are you sure you want to delete this dealer?',
        cancelText: 'Cancel',
        confirmText: 'Yes',
        type: 'is-danger',
        onConfirm: () => {
          this.$api('deleteDealer', { id: this.dealer.id })
            .then(resp => this.$emit('submitted'))
            .catch(err => {
              this.errMsg = `Could not delete dealer. ${err.toString()}`
              this.showErr = true
              this.submitting = false
            })
        }
      })
    },
    prepareDealer () {
      this.editDealer = Object.assign(this.getBlankDealer(), this.dealer || {})
      for (let cat of this.categories) {
        cat.selected = !!this.editDealer.categories.find(item => item.id === cat.id)
      }
    },
    getBlankDealer () {
      return {
        name: '',
        premium: false,
        address: '',
        city: '',
        state: '',
        postcode: '',
        web: '',
        phone: '',
        email: '',
        description: '',
        lat: null,
        lng: null,
        categories: []
      }
    }
  }
}
</script>

<style>
  .dealer-form .map {
    width: 100%;
    height: 500px;
  }
</style>
